





































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { timeout } from '@/utils/common'
import { ItemSenioridade } from '@/types/_'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'

@Component
export default class ViewFinanceiroTabelaSenioridade extends Vue {
  itemSenioridadeMode: string = 'CREATE'

  loadEditarItemSenioridade: string = ''
  get loadingEditarItemSenioridade() { return this.loadEditarItemSenioridade }
  set loadingEditarItemSenioridade(value: string) { this.loadEditarItemSenioridade = value }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDeleteItemSenioridade: boolean = false
  get loadingDeleteItemSenioridade() { return this.loadDeleteItemSenioridade }
  set loadingDeleteItemSenioridade(value: boolean) { this.loadDeleteItemSenioridade = value }

  itemToDelete: string = ''
  get itemToDeleteId() { return this.itemToDelete }
  set itemToDeleteId(value: string) { this.itemToDelete = value }

  modalDeleteItem: boolean = false
  get showModalDeleteItem() { return this.modalDeleteItem }
  set showModalDeleteItem(value: boolean) { this.modalDeleteItem = value }

  loadHistorico: string = ''
  get loadingHistorico() { return this.loadHistorico }
  set loadingHistorico(value: string) { this.loadHistorico = value }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get itemsSenioridadeTableHeader() {
    return [
      { text: 'Nome', value: 'nome', align: 'left', sortable: false },
      { text: 'Pontuação', value: 'codigoPontuacao', align: 'left', sortable: false },
      { text: 'Percentual', value: 'percentual', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsSenioridade() {
    return this.getFinanceiroStore.itemsSenioridade
  }

  criarItemSenioridade() {
    this.itemSenioridadeMode = 'CREATE'
    this.getFinanceiroStore.clearItemSenioridade()
    this.getFinanceiroStore.setModal({ name: 'criarEditarItemSenioridade', value: true })
  }

  async editarItemSenioridade(item: any) {
    this.itemSenioridadeMode = 'EDIT'
    this.getFinanceiroStore.clearItemSenioridade()
    this.loadingEditarItemSenioridade = item.id
    await timeout(500)
    this.getFinanceiroStore.setOriginalItemSenioridade({ ...item } as ItemSenioridade)
    this.getFinanceiroStore.setItemSenioridade({ ...item } as ItemSenioridade)
    this.getFinanceiroStore.setModal({ name: 'criarEditarItemSenioridade', value: true })
    this.loadingEditarItemSenioridade = ''
  }

  async apagarItemSenioridade() {
    this.loadingDeleteItemSenioridade = true
    const response = await this.getFinanceiroStore.deleteItemSenioridade(this.itemToDeleteId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Item apagado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      this.showModalDeleteItem = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDeleteItemSenioridade = false
  }

  async getAllItems() {
    this.loadingDataTable = true
    await this.getFinanceiroStore.getAllItemsSenioridade()
    await this.getFinanceiroStore.getTabelaPrecoAll()
    this.loadingDataTable = false
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    this.getHistoricoSituacaoStore.setIdForLoadItems(solicitacaoId)
    await this.getHistoricoSituacaoStore.getHistoricoSenioridade(solicitacaoId)
    this.loadingHistorico = ''
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.getFinanceiroStore.clearItemsSenioridade()
    this.getFinanceiroStore.clearItemSenioridade()
    await this.getAllItems()
    this.$ga.event('financeiro', 'acessar-tabela-itens-senioridade', this.$user.profile.email)
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.getFinanceiroStore.itemsSenioridadeTotal /  this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.itemsSenioridadePagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setItemsSenioridadePagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getFinanceiroStore.getAllItemsSenioridade()
    this.loadingDataTable = false
  }

  setItemToDelete(id: string) {
    this.itemToDeleteId = id
    this.showModalDeleteItem = !this.showModalDeleteItem
  }

  @Watch('showModalDeleteItem')
  onChangeShowModalDeleteItem(value) {
    if (!value) this.itemToDeleteId = ''
  }
}
